import { motion, AnimatePresence } from "framer-motion";
import { LuClock } from "react-icons/lu";
import { IoIosSearch, IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const SwipeSearchMobile = ({
  open,
  onClose,
  search,
  dataHistory,
  dataSearch,
  loadingSearch,
  isLogin,
  mutateDelete,
}) => {
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[999]"
            onClick={onClose}
          />

          <motion.div
            initial={{ y: "-100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed top-24 left-0 right-0 bg-white rounded-b-3xl z-[999] max-h-[70vh] flex flex-col shadow-2xl"
          >
            <div className="flex flex-col gap-4 pt-8 pb-4 px-4">
              {(search === "" || search === null) &&
              dataHistory &&
              dataHistory?.search_history.length > 0 ? (
                dataHistory?.search_history.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-1"
                    onClick={() =>
                      navigate(`/purchase/search-product/${item.keyword}`)
                    }
                  >
                    <div className="flex items-center gap-2">
                      <LuClock size={16} className="text-gray-500" />
                      <p className="text-md">{item.keyword}</p>
                    </div>
                    <IoMdClose
                      onClick={(e) => {
                        e.stopPropagation();
                        mutateDelete(item.search_id);
                      }}
                      size={16}
                      className="text-gray-500"
                    />
                  </div>
                ))
              ) : (search !== "" || search !== null) &&
                dataSearch &&
                dataSearch?.length > 0 ? (
                dataSearch?.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-1"
                    onClick={() =>
                      navigate(`/purchase/product-detail/${item.id}`)
                    }
                  >
                    <div className="flex items-center gap-2">
                      <IoIosSearch size={16} className="text-gray-500" />
                      <p className="text-md">{item.name}</p>
                    </div>
                  </div>
                ))
              ) : loadingSearch ? (
                <p className="text-md text-slate-500 italic px-2 py-1 animate-pulse">
                  Memuat...
                </p>
              ) : !isLogin ? (
                <p className="text-md text-slate-500 italic px-2 py-1">
                  Silahkan cari produk yang diinginkan
                </p>
              ) : (
                <p className="text-md text-slate-500 italic px-2 py-1">
                  Tidak ada hasil
                </p>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SwipeSearchMobile;
